export const new_orders_tab_selector = 'new-orders-tab' as const
export const now_orders_tab_selector = 'new-orders-tab' as const
export const pre_orders_tab_selector = 'new-orders-tab' as const
export const receiving_type_filter_selector = 'receiving-type-filter' as const